import { useEffect, useState, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import { CircularProgress } from "@mui/material";

export default function ManageRD() {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [breadcrumbs, setBreadcrumbs] = useState([{ label: "Dashboard", url: "/Dashboard" },]);
    const location = useLocation();

    const fetchDetails = useCallback(async () => {
        setLoading(true);
        try {
            const response = await fetch(`/api/getRD`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({}),
            });
            if (response.ok) {
                const Data = await response.json();
                setTransactions(Data);
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchDetails();
    }, [fetchDetails]);

    const lastBalance =
        transactions.length ? transactions[transactions.length - 1].Balance : 0;

    useEffect(() => {
        const routeParts = location.pathname.split("/").filter(Boolean);
        let url = "";
        const crumbs = [{ label: "Dashboard", url: "/Dashboard" }];
        routeParts.forEach((p) => {
            url += `/${p}`;
            crumbs.push({ label: p, url });
        });
        setBreadcrumbs(crumbs);
    }, [location]);

    return (
        <>
            <div className="mx-4 mt-4">
                <nav>
                    <ol className="flex text-sm text-gray-500 space-x-2">
                        {breadcrumbs.map((b, i) => (
                            <li key={i}>
                                {i !== breadcrumbs.length - 1 ? (
                                    <Link to={b.url} className="hover:text-blue-600">
                                        {b.label} /
                                    </Link>
                                ) : (
                                    <span className="text-gray-800">{b.label}</span>
                                )}
                            </li>
                        ))}
                    </ol>
                </nav>
            </div>
            <div className="p-3 sm:p-4 space-y-4">

                <div className="bg-gradient-to-r from-blue-600 to-cyan-500 text-white px-4 py-3 rounded-xl shadow">
                    <p className="text-xs opacity-80">Outstanding Balance</p>
                    <h2 className="text-2xl font-semibold">₹{lastBalance.toLocaleString()}</h2>
                </div>

                <div className="space-y-2">
                    {transactions.map((txn) => (
                        <div
                            key={txn.RDCID}
                            className="bg-white px-3 py-2 rounded-lg shadow-sm flex items-center justify-between border-l-4"
                            style={{
                                borderColor: txn.Amtdr > 0 ? "#3b82f6" : "#10b981",
                            }}
                        >
                            {/* Left */}
                            <div className="min-w-0">
                                <p className="text-sm font-medium text-gray-800 truncate">
                                    {txn.VoucherType}
                                </p>
                                <p className="text-xs text-gray-500">{txn.Date}</p>
                            </div>

                            {/* Middle Amount */}
                            <div className="text-xs sm:text-sm font-medium text-right">
                                {txn.Amtdr > 0 && (
                                    <p className="text-blue-600">+₹{txn.Amtdr.toLocaleString()}</p>
                                )}
                                {txn.Amtcr > 0 && (
                                    <p className="text-green-600">−₹{txn.Amtcr.toLocaleString()}</p>
                                )}
                            </div>

                            {/* Right Balance */}
                            <div className="text-right ml-3">
                                <p className="text-[10px] text-gray-500">Bal</p>
                                <p className="text-sm font-semibold text-gray-800">
                                    ₹{txn.Balance.toLocaleString()}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

                {loading && (
                    <div className="flex justify-center py-4">
                        <CircularProgress size={22} />
                    </div>
                )}
            </div>
        </>
    );
}


